import { AbstractInterface } from './AbstractInterface';
import { IACHub } from '../iacHub';
import { IACCommunication } from '../iacCommunication';

export class BannerInterface extends AbstractInterface {

  public static showBanner(): void {
    this.mediator.showBanner();
  }

  public static hideBanner(): void {
    this.mediator.hideBanner();
  }

  public static handleButtonClick(): void {
    const iacUsecase = IACCommunication.createUsecase('open_postal_avise', { m: 'navigator_tanreminder' });
    iacUsecase.asRPE();
    IACHub.handle(iacUsecase);
  }

}
